<template>
  <div>
    <Ibox :back="'true'" :titulo="'Agregar faena'">
      <b-col cols="12">
        <h4>Faena</h4>
      </b-col>
      <FormGroup
          cols="4"
          label="Empresa"
          :is_loading=loading_filtros>
        <v-select
            label="nombre_empresa"
            :clearable=false
            v-model="faena.id_empresa"
            :reduce="id_empresa=>id_empresa.id_empresa"
            :options=options_empresa
            placeholder="Seleccione una empresa">
        </v-select>
      </FormGroup>
      <FormGroup
          cols="4"
          label="Nombre faena">
        <input type="text" class="form-control" v-model="faena.nombre_faena">
      </FormGroup>
      <FormGroup cols="12" label="Descripción" >
        <textarea v-model="faena.descripcion_faena" class="md-textarea form-control" rows="4"></textarea>
      </FormGroup>
      <FormGroup
          cols="4"
          label="Supervisor faena"
          :is_loading=loading_filtros>
        <v-select multiple
            :value="faena.id_supervisor"
            label="nombre_usuario"
            :clearable=false
            :options=options_supervisor
            :reduce="id_supervisor=>id_supervisor.id_usuario"
            v-model="faena.id_supervisor"
            placeholder="Seleccione supervisor">
        </v-select>
      </FormGroup>
      <FormGroup
          cols="4"
          label="Fecha inicio">
        <Datepicker input-class="form-control" format="dd-MM-yyyy" v-model="faena.fecha_inicio" placeholder="Seleccione una fecha"></Datepicker>
      </FormGroup>
      <FormGroup
          cols="4"
          label="Fecha termino">
        <Datepicker input-class="form-control" format="dd-MM-yyyy" v-model="faena.fecha_termino" placeholder="Seleccione una fecha"></Datepicker>
      </FormGroup>
      <b-col v-if="utils.tienePermiso()" cols="12" align="right">
        <b-button v-if="loading_filtros" variant="primary"><Loading :size="'1'" :text="'Cargando datos'"/></b-button>
        <b-button v-else-if="loading" variant="primary"><Loading :size="'1'" :text="'Agregando faena'"/></b-button>
        <b-button v-else variant="primary" v-on:click="agregar()">Agregar faena</b-button>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import {empresaService, userService} from "../../services";
import {faenaServices} from "@/services/faena.services";
import { utils } from "@/helpers";

export default {
  name: 'Agregar',
  data(){
    return {
      loading_filtros:true,
      utils,
      loading:false,
      faena: {
        id_cliente:userService.getUser().id_cliente,
        id_empresa:null,
        nombre_faena:null,
        descripcion_faena:null,
        id_supervisor:null,
        fecha_inicio:null,
        fecha_termino:null
      },
      options_empresa:[],
      options_supervisor:[]
    }
  },
  mounted() {
    this.cargarEmpresas();
    this.cargarSupervisor();
  },
  methods: {
    cargarEmpresas(){
      this.loading_filtros = true;
      empresaService.getEmpresa(userService.getUser().id_empresa,'S').then(data => {
        this.options_empresa = data.data;
        this.loading_filtros = false;
      });
    },
    cargarSupervisor(){
      this.loading_filtros = true;
      faenaServices.getSupervisorFaena(this.faena).then(data => {
        this.options_supervisor = data.data;
        this.loading_filtros = false;

      });
    },
    agregar(){
      if (this.faena.nombre_faena && this.faena.id_empresa && this.faena.descripcion_faena && this.faena.id_supervisor && this.faena.id_supervisor != 0  && this.faena.fecha_inicio && this.faena.fecha_termino) {
        this.loading = true;
        faenaServices.postFaena(this.faena).then((data) => {
          utils.alerta(data);
          this.loading = false;

          if (data.status == "success") {
            this.$router.go(-1);
          }
        });

      }else{
        utils.alerta({msg:'Faltan campos obligatorios',status:'warning'});
      }
    },
  }
}
</script>